import React from 'react';
import Button from '../button/Button';
/* Banner requires heading and message, linkAction or linkUrl, and linkDisplay are optional */
export var AsureCloudIconBanner = function (_a) {
    var heading = _a.heading, message = _a.message, linkAction = _a.linkAction, linkUrl = _a.linkUrl, linkDisplay = _a.linkDisplay, icon = _a.icon, className = _a.className, darkBanner = _a.darkBanner;
    return (React.createElement("section", { className: "ACBanner icon " + (darkBanner ? 'dark' : '') + " shadow-sm d-flex flex-row justify-content-center justify-content-sm-between align-items-start align-items-sm-center " + className },
        React.createElement("svg", { className: "gradient-icon-banner" },
            React.createElement("defs", null,
                React.createElement("linearGradient", { id: "linear-icon-banner", gradientTransform: "rotate(45)" },
                    React.createElement("stop", { offset: "60%", stopColor: "#FFFFFF" }),
                    React.createElement("stop", { offset: "100%", stopColor: "#36A4C6" })))),
        React.createElement("div", { className: "icon pr-sm-4 pr-3" }, icon),
        React.createElement("div", { className: "d-flex flex-column flex-sm-row justify-content-start justify-content-sm-between align-items-start align-items-sm-center w-100" },
            React.createElement("div", { className: "messageArea d-flex flex-column justify-content-center align-items-start pb-sm-0 pb-1" },
                React.createElement("h1", { className: "bannerHeading font-weight-bold m-0 pb-sm-2 pb-1" }, heading),
                React.createElement("p", { className: "bannerMessage m-0" }, message)),
            React.createElement("div", { className: "linkArea d-flex flex-column justify-content-center align-items-center" },
                linkUrl && (React.createElement("a", { href: linkUrl, className: "btn " + (darkBanner ? 'btn-secondary' : 'btn-primary') + " btn-link" }, linkDisplay)),
                linkAction && (React.createElement(Button, { state: darkBanner ? 'secondary' : 'primary', text: linkDisplay, onClick: linkAction }))))));
};
export default AsureCloudIconBanner;
AsureCloudIconBanner.defaultProps = {
    heading: 'Important Banner Heading',
    message: 'Important banner message to be written here',
    borderColor: 'primary',
    linkDisplay: 'Acknowledge',
    linkUrl: '#',
    darkBanner: true,
};
//# sourceMappingURL=IconBanner.js.map